import p1 from '../assets/img/p-1.jpg'
import p2 from '../assets/img/p-2.jpg'
import p3 from '../assets/img/p-3.jpg'
import p4 from '../assets/img/p-4.jpg'
import p5 from '../assets/img/p-5.jpg'
import p6 from '../assets/img/p-6.jpg'

export const propertyFeature = [
    {
        title:'Bedrooms:',
        value:'3 Beds'
    },
    {
        title:'Bathrooms:',
        value:'2 Bath'
    },
    {
        title:'Areas:',
        value:'4,240 sq ft'
    },
    {
        title:'Garage:',
        value:'1'
    },
    {
        title:'Property Type:',
        value:'Apartment'
    },
    {
        title:'Year:',
        value:'Built 1982'
    },
    {
        title:'Status:',
        value:'Active'
    },
    {
        title:'Cooling:',
        value:'Central A/C'
    },
    {
        title:'Heating Type:',
        value:'Forced Air'
    },
    {
        title:'Kitchen Features:',
        value:'Kitchen Facilities'
    },
    {
        title:'Exterior:',
        value:'FinishBrick'
    },
    {
        title:'Swimming Pool:',
        value:'Yes'
    },
    {
        title:'Elevetor:',
        value:'Yes'
    },
    {
        title:'Fireplace:',
        value:'Yes'
    },
    {
        title:'Free WiFi:',
        value:'No'
    },
]
export const galleryImg = [
    p1,p2,p3,p4,p5,p6
]

export const featureProperty = [
    {
        image:p1,
        name:'oss vengel New Apartment',
        loction:'Sans Fransico',
        type:'For Sale',
        value:'$4,240'
    },
    {
        image:p4,
        name:'Montreal Quriqe Apartment',
        loction:'Liverpool, London',
        type:'For Rent',
        value:'$7,380'
    },
    {
        image:p6,
        name:'Curmic Studio For Office',
        loction:'Montreal, Canada',
        type:'For Buy',
        value:'$8,730'
    },
    {
        image:p5,
        name:'Montreal Quebec City',
        loction:'Sreek View, New York',
        type:'For Rent',
        value:'$6,240'
    },
]

export const userProperty = [
    {
        image:p1,
        name:'My List property Name',
        value:154,
        listed:'Listed in Rentals and Apartments',
        city:'KASIA',
        size:'Area:540 sq ft'
    },
    {
        image:p2,
        name:'My List property Name',
        value:154,
        listed:'Listed in Rentals and Apartments',
        city:'KASIA',
        size:'Area:540 sq ft'
    },
    {
        image:p3,
        name:'My List property Name',
        value:154,
        listed:'Listed in Rentals and Apartments',
        city:'KASIA',
        size:'Area:540 sq ft'
    },
    {
        image:p4,
        name:'My List property Name',
        value:154,
        listed:'Listed in Rentals and Apartments',
        city:'KASIA',
        size:'Area:540 sq ft'
    },
    {
        image:p5,
        name:'My List property Name',
        value:154,
        listed:'Listed in Rentals and Apartments',
        city:'KASIA',
        size:'Area:540 sq ft'
    },
    {
        image:p6,
        name:'My List property Name',
        value:154,
        listed:'Listed in Rentals and Apartments',
        city:'KASIA',
        size:'Area:540 sq ft'
    },
]

export const bookMarkProperty = [
    {
        image:p1,
        name:'Serene Uptown',
        loction:'6 Bishop Ave. Perkasie, PA',
        value:'$900 / monthly'
    },
    {
        image:p2,
        name:'Oak Tree Villas',
        loction:'71 Lower River Dr. Bronx, NY',
        value:'$535,000'
    },
    {
        image:p3,
        name:'Selway Villas',
        loction:'33 William St. Northbrook, IL',
        value:'$420,000'
    },
    {
        image:p4,
        name:'Town Manchester',
        loction:'7843 Durham Avenue, MD',
        value:'$420,000'
    },
]